import React from 'react';
import { CustomTemplate } from './CustomTemplate';
import { CustomGroup } from './CustomGroup';
import { CustomChildren } from './CustomChildren';
import { CustomIcon } from './CustomIcon';
import { CustomLink } from './CustomLink';
import { CustomMarkdown } from './CustomMarkdown';
import { TBaseTag, TBaseTagContext } from './types';
import { omit } from 'lodash';
import { CustomCollection } from './CustomCollection';
import CustomInputSimple from './CustomInputSimple';
import CustomInputButton from './CustomInputButton';
import CustomInputBoolean from './CustomInputBoolean';
import CustomInputImage from './CustomInputImage';
import { CustomForm } from './CustomForm';
import { CustomRequest } from './CustomRequest';
import { CustomArray } from './CustomArray';
import { CustomUnit } from './CustomUnit';

const TAG_MAP: Record<string, React.FC<any>> = {
  Template: CustomTemplate,
  Group: CustomGroup,
  Children: CustomChildren,
  Icon: CustomIcon,
  Link: CustomLink,
  Markdown: CustomMarkdown,
  CollectionContext: CustomCollection,
  FormContext: CustomForm,
  InputSimpleContext: CustomInputSimple,
  InputButtonContext: CustomInputButton,
  InputBooleanContext: CustomInputBoolean,
  InputImageContext: CustomInputImage,
  RequestContext: CustomRequest,
  ArrayContext: CustomArray,
  UnitContext: CustomUnit,
};

const CustomTag: React.FC<{
  name?: string;
  tagProps: Omit<TBaseTag, 'schema' | 'children'>;
  context: Partial<TBaseTagContext>;
  tagChildren: unknown;
}> = React.memo(({ name, tagProps, context, tagChildren }) => {
  const Tag = TAG_MAP[name || 'unknown'];

  if (!Tag || tagProps.excluded) {
    return null;
  }

  return (
    <Tag tagProps={omit(tagProps, 'excluded')} context={context}>
      {tagChildren}
    </Tag>
  );
});

CustomTag.displayName = 'CustomTag';

export default CustomTag;
